import { cva } from "class-variance-authority";

export const structuralRowColorVariants = cva("", {
  variants: {
    color: {
      default: "bg-background",
      muted: "bg-muted",
    },
  },
});

export const structuralRowTextVariants = cva("", {
  variants: {
    text: {
      default: "text-sm",
      uppercase: "text-xs uppercase text-muted-foreground",
    },
  },
});
